import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { HiMiniBars3CenterLeft } from 'react-icons/hi2';
import { IoClose } from 'react-icons/io5';
import { AiOutlineUser, AiOutlineTag, AiOutlineHome, AiOutlineCustomerService, AiOutlineContacts } from 'react-icons/ai';
import { SiWhatsapp } from 'react-icons/si';
import digitalmainlogo from '../assets/images/textlogoblack.png';
const Header = () => {
    const [headerMobile, setHeaderMobile] = useState(false)
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const navList = [{
        to: '/',
        name: 'Home',
        icon: <AiOutlineHome />
    },
    {
        to: '/about',
        name: 'About US',
        icon: <AiOutlineUser />
    },
    {
        to: '/services',
        name: 'Services',
        icon: <AiOutlineCustomerService />
    },
    {
        to: '/products',
        name: 'Products',
        icon: <AiOutlineTag />
    },
    {
        to: '/contactus',
        name: 'Contact Us',
        icon: <AiOutlineContacts />
    }
    ]

    useEffect(() => {
        window.addEventListener('scroll', isSticky);
        return () => {
            window.removeEventListener('scroll', isSticky);
        };
    });
    const isSticky = () => {
        const header = document?.querySelector('#header-section');
        const scrollTop = window.scrollY;
        scrollTop >= 150 ? header?.classList.add('sticky', 'top-0', 'animate__animated', 'animate__fadeInDown', 'border-b-2', 'border-sky-400') : header?.classList.remove('sticky', 'top-0', 'animate__animated', 'animate__fadeInDown', 'border-b-2', 'border-sky-400');
    };

    const chatwithwhatsapp = () => {
        window.open('https://api.whatsapp.com/send?phone=9054625310', '_blank')
    }
    return (
        <>
            <div className='fixed bottom-[10px] right-[10px] z-[999999]'>
                <div className='relative w-fit h-fit group'>
                    <button type='button' className='w-[40px] h-[40px] md:w-[50px] md:h-[50px] md:text-[30px] bg-sky-400 hover:bg-white hover:border-sky-400 hover:text-sky-400 transition-all border-2 rounded-xl flex justify-center items-center text-[18px] text-white border-white' onClick={() => { chatwithwhatsapp() }}>
                        <SiWhatsapp />
                    </button>
                    <div className='absolute top-2/4 -translate-y-2/4 right-[105%]'>
                        <div className='w-fit h-[40px] md:h-[50px] scale-0 transition-all group-hover:scale-100 bg-white text-sky-400 border-2 border-sky-400 whitespace-nowrap p-[10px] text-[16px] md:text-[20px] rounded-xl font-semibold flex justify-center items-center'>Sales & Support</div>
                    </div>
                </div>
            </div>
            <header className='bg-white z-[9999]' id='header-section'>
                <div className='w-full mx-0 md:w-[90%] md:mx-auto relative'>
                    <div className='flex justify-between items-center p-[15px]'>
                        <div className='flex gap-[10px] items-center'>
                            <img src={digitalmainlogo} alt="DIGITAL HOUSE" title="DIGITAL HOUSE" width={80} />
                            <p className='text-sky-400 font-semibold text-[20px]'>DIGITAL HOUSE</p>
                        </div>
                        <div className='hidden md:inline-block'>
                            <ul className='flex gap-4 items-center'>
                                {
                                    navList?.map((data, index) => {
                                        return (
                                            <li key={index}><button className={`text-[18px] outline-none flex items-center gap-[10px] py-[5px] font-[600] transition-all ${pathname === data?.to ? 'text-sky-400' : 'text-black hover:text-sky-400'}`} onClick={() => { navigate(data?.to) }}>{data?.icon} {data?.name}</button></li>
                                        )
                                    })
                                }
                            </ul>
                        </div>
                        <div className='inline-block md:hidden'>
                            <button type='button' onClick={() => { setHeaderMobile(!headerMobile) }} className='text-sky-400 text-[25px] w-[40px] h-[40px] rounded-full flex justify-center items-center'>
                                {headerMobile ? <IoClose /> : < HiMiniBars3CenterLeft />}
                            </button>
                        </div>
                    </div>
                    <div className={`absolute top-[75px] right-0 transition-all ${headerMobile ? 'scale-100' : 'scale-0'} inline-block md:hidden z-[9999]`}>
                        <div className={`bg-white border-2 border-sky-400 w-fit py-[20px] px-[50px] rounded-[25px]`}>
                            <ul className='flex gap-4 flex-col items-center justify-center'>
                                {
                                    navList?.map((data, index) => {
                                        return (
                                            <li key={index}><button className={`text-[18px] outline-none flex items-center gap-[10px] py-[5px] font-[600] transition-all ${pathname === data?.to ? 'text-sky-600' : 'text-black hover:text-sky-600'}`} onClick={() => { setHeaderMobile(false); navigate(data?.to) }}>{data?.icon} {data?.name}</button></li>
                                        )
                                    })
                                }
                            </ul>
                        </div>
                    </div>
                </div >
            </header>
        </>
    );
};

export default Header;